'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var handler = HANDLERS[action.type] || function () {
        return state;
    };
    return handler(action.payload, state);
};

var _WixInstance = require('@wix/wixrest-utils/dist/WixInstance');

var _WixInstance2 = _interopRequireDefault(_WixInstance);

var _WixInstanceActions = require('../actions/WixInstanceActions');

var WixInstanceActions = _interopRequireWildcard(_WixInstanceActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// All Wix TPAs in the editor/preview/viewer are initialized with a Wix Instance
// to tell them various information about the environment (eg. instanceId, userId,
// etc...)
// This reducer will holder the Wix Instance used to initialize the system.

var INITIAL_STATE = {
    instance: null
};

var HANDLERS = (0, _defineProperty3.default)({}, WixInstanceActions.types.SET_INSTANCE, function (payload, state) {
    _WixInstance2.default.init(payload.instance, payload.appId);

    var parsed = _WixInstance2.default.getParsedInstance() ? _.extend({}, _WixInstance2.default.getParsedInstance(), {
        permissions: _WixInstance2.default.getPermissions()
    }) : null;

    return (0, _extends3.default)({}, state, {
        value: payload.instance,
        appId: payload.appId,
        instance: _WixInstance2.default,
        parsed: parsed
    });
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/reducers/WixInstanceReducer.js
// module id = 855
// module chunks = 0